// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 518) return "static/chunks/518-3b674347b6552386.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 954 ? "eb6e03f4" : chunkId) + "." + {"24":"0fcad4f1fe5f5d91","284":"03f91a926f1f6af1","319":"bae7cff2935fcdf2","382":"e4e6c7be7e7237f0","522":"36a4d34835fd9b83","548":"63e2eb42a9948184","667":"edd12a33f5150371","678":"468e7ad48202fab3","746":"a80ff3b322f3198b","757":"5e0f6d45dc0a3274","954":"531fef25d19081e5"}[chunkId] + ".js";
};